module.exports = __webpack_public_path__ + "static/media/reception.b38f61fa.png";